import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { updatePromoCodeSuccess, updatePromoCodeFailure } from "../../Action/auth/updatePromoCodeAction";
import { UPDATE_PROMO_CODE } from "../../Action/actionTypes";

function* updatePromoCodeRequest(action) {
  try {
    const { userId, promoCode } = action.payload;
    const { data } = yield notifyPromise(API.put(`/update-promo-code`, { userId, promoCode }));

    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }

    if (data?.meta?.code === 200) {
      yield put(updatePromoCodeSuccess(data?.data));
    } else {
      yield put(updatePromoCodeFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(updatePromoCodeFailure());
  }
}

export function* watchUpdatePromoCode() {
  yield takeEvery(UPDATE_PROMO_CODE, updatePromoCodeRequest);
}

export default function* rootSaga() {
  yield all([watchUpdatePromoCode()]);
}
